<template>
  <div class="row">
    <div class="col-12">
      <div v-if="serverState !== null">
        <h4>
          Server state: {{ serverState }}
        </h4>
      </div>
      <div v-if="buildDate">
        <h4>
          Build Date: {{ buildDate }}
        </h4>
      </div>
      <div v-if="gitHash">
        <h4>
          Commit: #{{ gitHash }}
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import hashAndDate from '@/assets/hash.json';
import axios from 'axios';
const serviceUrl = process.env.VUE_APP_SOCKET_URL+':'+process.env.VUE_APP_SOCKET_PORT;
console.log("serviceUrl="+serviceUrl);


export default {
  name: 'BuildInfo',
  data() {
    return {
      serverState: null,
      buildDate: hashAndDate.date,
      gitHash: hashAndDate.hash
    };
  },
  mounted() {
    axios.get(serviceUrl+'/healthcheck')
      .then(response => {
        if (response.data === 'OK!') {
          this.serverState = 'OK';
        } else {
          this.serverState = 'ERROR';
        }
      })
      .catch(error => {
        this.serverState = error && error.message ? error.message : 'ERROR';
      });
  }
}
</script>

<style scoped>
h4 {
  text-align: center; font-size: 14px; color: lightgray;
}
</style>